import React from "react";
import PropTypes from "prop-types";
import { Row } from "reactstrap";
import { choices } from "./styles/Choices.module.scss";

export default class Choices extends React.Component {
  static propTypes = {
    children: PropTypes.node.isRequired
  };

  render() {
    return (
      <Row className={choices} data-selector='choices'>
        {this.props.children}
      </Row>
    );
  }
}
